import React, { useState, useContext, useEffect, useRef } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { UserContext } from '../contexts/userContext';
import { useHistory } from 'react-router';
import Swal from 'sweetalert2';
import { Email, Inventory, Settings, Security } from '@mui/icons-material';
import { Box, Paper, alpha, ButtonGroup, Switch, FormControlLabel, Divider, Chip } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ModernPageContainer, ModernPageHeader } from '../dashboard/components/ModernTable';

import { useForm } from 'react-hook-form';
import request from '../../services/Request';
import './form.css';

export default function ChangePassWord() {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const changePasswordURL = `/users/edit/changePassword`;
  const changeEmailURL = `/users/edit/changeEmail`;
  const changeStockingURL = `/users/edit/changeStocking`;

  const defaultValues = {
    role: 'User',
  };

  const form2 = {
    email: user?.email,
  };

  const form3 = {};

  //use to fix style bug

  const { userEmail } = useContext(UserContext);
  const [refresh, setRefresh] = useState(false);
  const [stk, setstk] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [twoFAEnabled, setTwoFAEnabled] = useState(false);
  const [twoFALoading, setTwoFALoading] = useState(false);

  const {
    register,
    watch,
    handleSubmit,
    setError,
    formState: { errors },
  } = useForm({ defaultValues });

  const {
    register: register2,
    watch: watch2,
    handleSubmit: handleSubmit2,
    setError: setError2,
    reset: reset2,
    formState: { errors: errors2 },
  } = useForm({ form2 });

  const {
    register: register3,
    handleSubmit: handleSubmit3,
    setError: setError3,
    formState: { errors: errors3 },
  } = useForm({ form3 });

  const password = useRef({});
  password.current = watch('newPassword', '');

  const watchAll = watch2();
  let history = useHistory();

  const onSubmit = async (data) => {
    request({
      method: 'patch',
      url: changePasswordURL,
      data: {
        email: userEmail,
        oldPassword: data.oldPassword,
        newPassword: data.newPassword2,
      },
    })
      .then((res) => {
        Swal.fire({
          text: `Your password has been changed`,
          icon: 'success',
        }).then(() => {
          history.push('/dashboard');
        });
      })
      .catch((err) => {
        if (err && err.response) {
          setError('oldPassword', {
            message: err.response.data.message,
          });
        }
      });
  };

  const onSubmitEmail = async (data) => {
    const email2 = data.email === '' ? userEmail : data.email;
    request({
      method: 'patch',
      url: changeEmailURL,
      data: {
        email: userEmail,
        password: data.password,
        email2: email2,
      },
    })
      .then((res) => {
        Swal.fire({
          text: `Your associated email has been changed`,
          icon: 'success',
        }).then(() => {
          history.push('/dashboard');
        });
      })
      .catch((err) => {
        if (err && err.response) {
          setError2('email', {
            message: err.response.data.message,
          });
        }
      });
  };

  const onSubmitStocking = async (data) => {
    request({
      method: 'patch',
      url: changeStockingURL,
      data: {
        email: userEmail,
        password: data.password1,
        stocking: data.stocking,
      },
    })
      .then((res) => {
        Swal.fire({
          text: `Your stocking password has been changed`,
          icon: 'success',
        }).then(() => {
          history.push('/dashboard');
        });
      })
      .catch((err) => {
        if (err && err.response) {
          setError3('stocking', {
            message: err.response.data.message,
          });
        }
      });
  };

  useEffect(() => {
    setRefresh(false);
    request({
      method: 'get',
      url: `/users/edit/${user?._id}`,
    }).then((res) => {
      reset2({
        email: res.data.email2 ? res.data.email2 : res.data.email,
      });
      setRefresh(true);
      if (res.data.stocking && res.data.stocking !== '') {
        setstk(true);
      }
      if (res.data.twoFA) {
        setTwoFAEnabled(res.data.twoFA);
      }
    });
  }, []);

  const handleTwoFAToggle = async (e) => {
    const enabled = e.target.checked;
    setTwoFALoading(true);
    try {
      await request({
        method: 'patch',
        url: '/users/2fa',
        data: { email: userEmail, twoFA: enabled },
      });
      setTwoFAEnabled(enabled);
      Swal.fire({
        text: enabled ? 'Two-factor authentication enabled' : 'Two-factor authentication disabled',
        icon: 'success',
        timer: 2000,
        showConfirmButton: false,
      });
    } catch (err) {
      Swal.fire({ text: 'Failed to update 2FA setting', icon: 'error' });
    } finally {
      setTwoFALoading(false);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <ModernPageContainer>
      <ModernPageHeader
        title="Account Settings"
        subtitle="Manage your password, email, and security settings"
        icon={Settings}
      />

      <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Button Group Navigation */}
        <ButtonGroup
          variant="outlined"
          sx={{
            mb: 3,
            '& .MuiButton-root': {
              px: 3,
              py: 1,
              textTransform: 'none',
              fontSize: '0.875rem',
              fontWeight: 600,
            },
          }}
        >
          <Button
            variant={tabValue === 0 ? 'contained' : 'outlined'}
            startIcon={<LockOutlinedIcon />}
            onClick={() => setTabValue(0)}
          >
            Password
          </Button>
          <Button
            variant={tabValue === 1 ? 'contained' : 'outlined'}
            startIcon={<Email />}
            onClick={() => setTabValue(1)}
          >
            Email
          </Button>
          {stk && (
            <Button
              variant={tabValue === 2 ? 'contained' : 'outlined'}
              startIcon={<Inventory />}
              onClick={() => setTabValue(2)}
            >
              Stocking
            </Button>
          )}
          <Button
            variant={tabValue === 3 ? 'contained' : 'outlined'}
            startIcon={<Security />}
            onClick={() => setTabValue(3)}
          >
            Security
          </Button>
        </ButtonGroup>

        {/* Content Paper */}
        <Paper
          elevation={0}
          sx={{
            borderRadius: 2,
            width: '100%',
            maxWidth: 600,
            border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            p: 3,
          }}
        >
          {/* Tab 0: Change Password */}
          {tabValue === 0 && (
            <Box sx={{ maxWidth: 400, mx: 'auto' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                    Change Password
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit(onSubmit)} noValidate>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  autoComplete="oldPassword"
                  name="oldPassword"
                  variant="outlined"
                  required
                  fullWidth
                  id="oldPassword"
                  type="password"
                  label="Old Password"
                  autoFocus
                  {...register('oldPassword', {
                    required: 'Old Password is required',
                    minLength: {
                      value: 8,
                      message: 'Password must longer than 8',
                    },
                  })}
                />
                {errors.oldPassword && (
                  <p className="signUpErrorMessage">{errors.oldPassword.message}</p>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="newPassword"
                  label="New Password"
                  name="newPassword"
                  type="password"
                  autoComplete="newPassword"
                  {...register('newPassword', {
                    required: 'New Password is required',
                    minLength: {
                      value: 8,
                      message: 'Password must longer than 8',
                    },
                  })}
                />
                {errors.newPassword && (
                  <p className="signUpErrorMessage">{errors.newPassword.message}</p>
                )}
              </Grid>
              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  required
                  fullWidth
                  id="newPassword2"
                  label="Enter password again"
                  name="newPassword2"
                  type="password"
                  autoComplete="newPassword2"
                  {...register('newPassword2', {
                    required: 'Re-Enter Password is required',
                    minLength: {
                      value: 8,
                      message: 'Password must longer than 8',
                    },
                    validate: (value) =>
                      value === password.current || 'The new passwords do not match',
                  })}
                />
                {errors.newPassword2 && (
                  <p className="signUpErrorMessage">{errors.newPassword2.message}</p>
                )}
              </Grid>
            </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3 }}
                  >
                    Change My Password
                  </Button>
                </form>
              </Box>
            )}

            {/* Tab 1: Change Email */}
            {tabValue === 1 && refresh && (
              <Box sx={{ maxWidth: 400, mx: 'auto' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                    Change Associated Email
                  </Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, textAlign: 'center' }}>
                    All emails will send to this associated email instead of your account username
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit2(onSubmitEmail)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type="password"
                    label="Password"
                    {...register2('password', {
                      required: 'Password is required',
                      minLength: {
                        value: 8,
                        message: 'Password must longer than 8',
                      },
                    })}
                  />
                  {errors2.password && (
                    <p className="signUpErrorMessage">{errors2.password.message}</p>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    label="Email"
                    value={watchAll?.email}
                    {...register2('email', {
                      pattern: {
                        value:
                          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                        message: 'Please enter a valid email',
                      },
                    })}
                  />
                  {errors2.email && <p className="signUpErrorMessage">{errors2.email.message}</p>}
                </Grid>
              </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3 }}
                  >
                    Change Email
                  </Button>
                </form>
              </Box>
            )}

            {/* Tab 2: Change Stocking Password */}
            {tabValue === 2 && stk && (
              <Box sx={{ maxWidth: 400, mx: 'auto' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                    Change Stocking Password
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit3(onSubmitStocking)} noValidate>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type="password"
                    label="Password"
                    {...register3('password1', {
                      required: 'Password is required',
                      minLength: {
                        value: 8,
                        message: 'Password must longer than 8',
                      },
                    })}
                  />
                  {errors3.password1 && (
                    <p className="signUpErrorMessage">{errors3.password1.message}</p>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    variant="outlined"
                    required
                    fullWidth
                    type="password"
                    label="Stocking"
                    {...register3('stocking', {
                      required: 'Stocking is required',
                      minLength: {
                        value: 5,
                        message: 'Length of stocking should be 5',
                      },
                      maxLength: {
                        value: 5,
                        message: 'Length of stocking should be 5',
                      },
                    })}
                  />
                  {errors3.stocking && (
                    <p className="signUpErrorMessage">{errors3.stocking.message}</p>
                  )}
                </Grid>
              </Grid>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    color="primary"
                    sx={{ mt: 3 }}
                  >
                    Change Stocking Password
                  </Button>
                </form>
              </Box>
            )}
          {/* Tab 3: Security / 2FA */}
          {tabValue === 3 && (
            <Box sx={{ maxWidth: 400, mx: 'auto' }}>
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
                <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                  Two-Factor Authentication
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, textAlign: 'center' }}>
                  When enabled, a one-time verification code will be sent to your email each time you sign in. Codes expire after 10 minutes.
                </Typography>
              </Box>
              <Divider sx={{ mb: 3 }}>
                <Chip label="2FA Settings" size="small" />
              </Divider>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  borderRadius: 2,
                  border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                  bgcolor: twoFAEnabled
                    ? alpha(theme.palette.success.main, 0.05)
                    : alpha(theme.palette.action.hover, 0.05),
                }}
              >
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    Email verification code
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {twoFAEnabled ? 'Currently enabled' : 'Currently disabled'}
                  </Typography>
                </Box>
                <FormControlLabel
                  control={
                    <Switch
                      checked={twoFAEnabled}
                      onChange={handleTwoFAToggle}
                      disabled={twoFALoading}
                      color="success"
                    />
                  }
                  label=""
                />
              </Box>
            </Box>
          )}
        </Paper>
      </Box>
    </ModernPageContainer>
  );
}
